import {
	arbitrum,
	base,
	baseSepolia,
	bsc,
	// mainnet,
	optimism,
	optimismSepolia,
	polygon,
} from "wagmi/chains";

export interface Token {
	symbol: string;
	icon: string;
	chains: {
		address: `0x${string}`;
		balance?: string | bigint;
		chainIcon: string;
		chainId: number;
		chainName: string;
		decimals?: number;
		net?: string;
	}[];
}

export const PAY_TOKENS: Token[] = [
	{
		symbol: "USDT",
		icon: "/assets/icons/chains/usdt.svg",
		chains: [
			{
				chainId: base.id,
				address: "0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2",
				chainName: base.name,
				chainIcon: "/assets/icons/chains/Base_Network_Logo.svg",
			},
			{
				chainId: optimism.id,
				address: "0x94b008aA00579c1307B0EF2c499aD98a8ce58e58",
				chainName: optimism.name,
				chainIcon: "/assets/icons/chains/optimism-logo.svg",
			},
			{
				chainId: arbitrum.id,
				address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
				chainName: arbitrum.name,
				chainIcon: "/assets/icons/chains/arbitrum-arb-logo.svg",
			},
			{
				chainId: polygon.id,
				address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
				chainName: polygon.name,
				chainIcon: "/assets/icons/chains/polygon-matic-logo.svg",
			},
			{
				chainId: bsc.id,
				address: "0x55d398326f99059fF775485246999027B3197955",
				chainName: bsc.name,
				chainIcon: "/assets/icons/chains/bnb-logo.svg",
			},
			{
				chainId: baseSepolia.id,
				address: "0x5c223cF0cD04B27560bb060db52070C1D781e3Ce",
				chainName: baseSepolia.name,
				chainIcon: "/assets/icons/chains/Base_Network_Logo.svg",
			},
		],
	},
	{
		symbol: "USDC",
		icon: "/assets/images/deposit/usdc.svg",
		chains: [
			{
				chainId: base.id,
				address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
				chainName: base.name,
				chainIcon: "/assets/icons/chains/Base_Network_Logo.svg",
			},
			{
				chainId: optimism.id,
				address: "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85",
				chainName: optimism.name,
				chainIcon: "/assets/icons/chains/optimism-logo.svg",
			},
			{
				chainId: arbitrum.id,
				address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
				chainName: arbitrum.name,
				chainIcon: "/assets/icons/chains/arbitrum-arb-logo.svg",
			},
			{
				chainId: polygon.id,
				address: "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359",
				chainName: polygon.name,
				chainIcon: "/assets/icons/chains/polygon-matic-logo.svg",
			},
			{
				chainId: bsc.id,
				address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
				chainName: bsc.name,
				chainIcon: "/assets/icons/chains/bnb-logo.svg",
			},
		],
	},
];

const isTestnet = import.meta.env.MODE === "development";
// console.log("mode: ", import.meta.env.MODE);

const testnetIds: number[] = [baseSepolia.id, optimismSepolia.id];

export const PAYMENT_CONTRACT =
	import.meta.env.MODE === "development"
		? "0xbd7f2332A2Dcf47DCdB50bfC5e902e4D59ef3569"
		: "0x956da71CB4A74754884909B64b8D5474c66017b6";

export const PAY_TOKENS_FILTERED: Token[] = PAY_TOKENS.map((token) => ({
	...token,
	chains: token.chains
		.filter(
			(chain) => isTestnet || !testnetIds.includes(chain.chainId as number),
		)
		.map((chain) => ({
			...chain,
			net: testnetIds.includes(chain.chainId as number) ? "Test Net" : "",
		})),
})).filter((token) => token.chains.length > 0);
